(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initCustomCursor = () => {
    // Create custom cursor element
    let cursor = document.querySelector('.product-zoom-cursor');
    if (!cursor) {
      cursor = document.createElement('div');
      cursor.className = 'product-zoom-cursor';
      document.body.appendChild(cursor);
    }

    // Get all zoom trigger elements
    const zoomTriggers = document.querySelectorAll('.product__media-toggle, .product-media-modal__content');

    // Mouse move handler
    const moveCursor = (e) => {
      cursor.style.left = e.clientX - 24 + 'px'; // Center the 48px cursor
      cursor.style.top = e.clientY - 24 + 'px';
    };

    // Add event listeners to zoom triggers
    zoomTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        cursor.classList.add('active');
        document.addEventListener('mousemove', moveCursor);
      });

      trigger.addEventListener('mouseleave', () => {
        cursor.classList.remove('active');
        document.removeEventListener('mousemove', moveCursor);
      });
    });
  };

  const crossGalleryHandles = new Set([
    "solene-pave-cross-necklace",
    "celeste-cross-necklace",
    "ines-cross-birthstone-necklace",
    "estelle-sideways-cross-necklace",
    "elysia-cross-necklace",
    "trinity-cross-disc-birthstone-necklace",
    "lucia-cross-diamond-bracelet",
    "amelie-cross-ring",
    "evangelina-cross-birthstone-pendant-necklace",
    "evangelina-cross-birthstone-tennis-ring",
    "evangelina-cross-birthstone-tennis-bracelet",
    "aurelia-cross-tennis-ring",
    "rosalia-cross-tennis-bracelet"
]);

  const initCrossGalleryResolution = () => {
    const handle = window.location.pathname.split('/products/')[1]?.split('/')[0];
    if (!crossGalleryHandles.has(handle)) return;

    document.querySelectorAll('product-modal').forEach(modal => {
      if (modal.dataset.suriCrossZoomReady) return;
      modal.dataset.suriCrossZoomReady = 'true';

      const loadActiveOriginal = () => {
        if (!modal.hasAttribute('open')) return;
        const image = modal.querySelector('.swiper-slide-active .js-image-zoom');
        if (!image || !image.hasAttribute('srcset')) return;
        const source = image.getAttribute('src');
        if (!source) return;
        image.decoding = 'async';
        image.loading = 'eager';
        image.removeAttribute('sizes');
        image.removeAttribute('srcset');
      };

      new MutationObserver(loadActiveOriginal).observe(modal, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        childList: true,
        subtree: true
      });
      loadActiveOriginal();
    });
  };

  const initZoomImage = () => {
    initCrossGalleryResolution();
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initCustomCursor();
  });

  initProductAccordion();
  initZoomImage();
  initCustomCursor();
})();
